export const extarctOnlyMonth = (timestamp) => {
  const dateObject = new Date(timestamp);
  // return dateObject.toLocaleDateString("en-US", { month: "short" });
  return dateObject.toLocaleDateString("en-US", { month: "short", year: "numeric" });
};

// output is Jan
